export default "__VITE_ASSET__4e1b8aa8__"